import { HeaderButton } from "@Components/game/header/styled-components";
import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import Icon from "@Components/generic/icon";
import { Events } from "@Context/common/general/context";
import VRHeaderButtonType from "@Enums/VRHeaderButtonType";
import { faSlidersSimple } from "@fortawesome/pro-solid-svg-icons";
import { formatTag } from "@Helpers/formatters";
import { useApi, useGlobalContext } from "@hooks/index";
import { useTheme } from "@mui/material";
import { Api } from "@Shared/schemas";
import { PlaylistResponse } from "@Shared/schemas/playlists/playlistSchemas";
import { useEffect, useState } from "react";
import { useMount } from "react-use";

export const usePlaylistCategory = (tag: string) => {
  const { globalState } = useGlobalContext();
  const isSuperAdmin = globalState.user.isSuperAdmin;
  const [playlists, setPlaylists] = useState<PlaylistResponse[]>([]);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filters, setFilters] = useState<string[]>([]);
  const theme = useTheme();

  const { call: getPlaylists, loading } = useApi<typeof Api.Playlists.GetPlaylists>({
    api: Api.Playlists.GetPlaylists,
    request: {
      account_id: globalState.account.id!,
      exclude_tags: !isSuperAdmin ? ["QA", "DEVELOPMENT"] : [],
      ...(tag && tag !== "all" ? { include_tags: [tag] } : {}),
      unpublished_allowed: isSuperAdmin,
    },
    onSuccess: (response: { code: string; data: PlaylistResponse[] }) => {
      if (response.code !== "ok" || response.data.length <= 0) return;
      setPlaylists(response.data);
    },
  });

  useMount(() => {
    Events.app.showHeaderButton.emit({ type: VRHeaderButtonType.BACK, title: formatTag(tag) });
    getPlaylists();
  });

  useEffect(() => {
    Events.app.setHeaderAltSections.emit({
      rightSection: (
        <HapticsButtonWrapper>
          <HeaderButton onClick={() => setFilterModalOpen(true)}>
            <Icon icon={faSlidersSimple} color={theme.palette.dsBase.v200} fontSize={24} />
          </HeaderButton>
        </HapticsButtonWrapper>
      ),
    });
    return () => Events.app.setHeaderAltSections.emit();
  }, []);

  return {
    playlists,
    loading,
    filterModalOpen,
    setFilterModalOpen,
    filters,
    setFilters,
  };
};
